import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import "./LoginScreen.css";

export default function LoginScreen() {
  const { instance } = useMsal();
  const handleLogin = () => instance.loginRedirect(loginRequest).catch((e) => console.error(e));

  return (
    <div className="login-shell">
      <div className="login-card fade-up">
        <div className="login-logo"><span className="login-mark">◈</span></div>
        <h1 className="login-title">Proximity Dispatch</h1>
        <p className="login-sub">Scheduler tool for finding the nearest available caregivers</p>
        <button className="login-btn" onClick={handleLogin}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1 1h7.5v7.5H1V1z" fill="#F25022"/>
            <path d="M9.5 1H17v7.5H9.5V1z" fill="#7FBA00"/>
            <path d="M1 9.5h7.5V17H1V9.5z" fill="#00A4EF"/>
            <path d="M9.5 9.5H17V17H9.5V9.5z" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>
        <p className="login-note">Use your NursePartners Microsoft 365 account</p>
      </div>
    </div>
  );
}
